import React, { useContext, useEffect, useState } from 'react'
import { ChartBar, ChartDonutCustomer, ChartDonutProduct, ChartLine, ChartLineSolution, HeaderWeb, SidebarComponent, UserInformationProgress } from '../../components'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { AuthContext, ThemeContext } from '../../auth';
import { useMediaQuery } from 'react-responsive';
import Swal from 'sweetalert2';
import GaugeChart from 'react-gauge-chart';
import { axiosAuth } from '../../api';

function Dashboard() {

    const { theme } = useContext(ThemeContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [monthlyLead, setMonthlyLead] = useState({});
    const [userInformation, setUserInformation] = useState({});

    const retrieveMonthlyLead = () => {
        setLoading(true);
        axiosAuth.get(`/api/analytics/barchart?userId=${userInfo?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setMonthlyLead(res?.data?.data);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    const retrieveUserInformation = () => {
        setLoading(true);
        axiosAuth.get(`/api/analytics/information?userId=${userInfo?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setUserInformation(res?.data?.data);

                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            })
    };


    useEffect(() => {
        if (accessToken !== undefined && userInfo?.id !== undefined) retrieveMonthlyLead();
        if (accessToken !== undefined && userInfo?.id !== undefined) retrieveUserInformation();
    }, [accessToken, userInfo?.id]);

    const [listLead, setListLead] = useState([]);
    const [averageLead, setAverageLead] = useState(0);

    const retrieveLead = () => {
        setLoading(true);
        axiosAuth.get(`/api/leads?userId=${userInfo?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filteredData = res.data.data.filter(item => item.status != 100 && item.status != 0);

                setListLead(filteredData);

                if (filteredData.length > 0) {
                    const totalStatus = filteredData.reduce((sum, item) => sum + item.status, 0);
                    const avg = totalStatus / filteredData.length;
                    setAverageLead(Math.round(avg));
                } else {
                    setAverageLead(0);
                }

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined && userInfo?.id !== undefined) retrieveLead();
    }, [accessToken, userInfo?.id]);

    const successRate =
        userInformation?.totalSuccessLeadYearly && userInformation?.totalLeadYearly
            ? (userInformation.totalSuccessLeadYearly / userInformation.totalLeadYearly) * 100
            : 0;

    const chartStyle = {
        fontFamily: 'Roboto-Bold',
        marginTop: '30px',
        marginBottom: '30px'
    }


    const [selectedDate, setSelectedDate] = useState('');

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');

    const maxDate = `${year}-${month}`;

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
            fontFamily: 'Poppins-Regular',
            height: '3.2rem',
            borderColor: '#b4b4b4ff',
        },
    };

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            <div className='mb-3' style={{
                backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
                width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                transition: '0.8s'
            }}>
                <Row >
                    <Col xs={6} lg={6} className='text-start'>
                        <h4 className='ms-4 pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '20px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                            Dashboard  {userInfo?.firstName + " " + userInfo?.lastName}
                        </h4>
                    </Col>
                    <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                        <HeaderWeb />
                    </Col>
                </Row>
            </div>
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'mx-2' : 'ms-3 pt-3 me-1'}>
                    <div style={{ marginTop: isMobile ? '20px' : '40px' }}>
                        <Row>
                            <Col xs={12} lg={8}>
                                <Card
                                    className={isMobile ? 'w-100' : ' w-100'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <ChartLine id={userInfo?.id} accessToken={accessToken} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={12} lg={4} className={isMobile ? 'mt-4' : ''}>
                                <Card
                                    className={isMobile ? '' : 'mx-2'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%'
                                    }}
                                >
                                    <Card.Body className='text-center'>
                                        <p
                                            className='ps-1 py-2 text-start'
                                            style={{
                                                marginBottom: '0px',
                                                marginTop: '0px',
                                                fontFamily: 'Poppins-Bold',
                                                fontSize: '20px',
                                                color: theme === 'light' ? '#FFFFFF' : '#222'
                                            }}
                                        >
                                            Success Rate
                                        </p>
                                        <GaugeChart
                                            style={chartStyle}
                                            hideText={true}
                                            percent={successRate / 100}
                                            colors={
                                                theme === 'light' ?
                                                    ['#9ed1e4ff', '#82c6dfff', '#55bfe6ff', '#3db5e0ff', '#12B3ED']
                                                    :
                                                    ['#5C9EFF', '#5590f3', '#3c77e0', '#1c5fc8', '#0047AB']
                                            }
                                            nrOfLevels={5}
                                            needleColor={theme === 'light' ? 'white' : '#acacac'}
                                            needleBaseColor={theme === 'light' ? 'white' : '#acacac'}
                                        />
                                        <p
                                            className='mt-4 text-center'
                                            style={{
                                                fontFamily: 'Poppins-Bold',
                                                fontSize: '20px',
                                                color: theme === 'light' ? '#FFFFFF' : '#222'
                                            }}
                                        >
                                            {successRate.toFixed(2) + '%'}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col>
                                <Card
                                    className={isMobile ? 'w-100' : 'me-2'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <ChartLineSolution
                                            id={userInfo?.id}
                                            accessToken={accessToken}
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className={`${isMobile ? 'mt-2' : 'my-3'} d-flex align-items-stretch`}>
                            <Col xs={12} lg={4} className="mt-3">
                                <UserInformationProgress
                                    userInformation={userInformation}
                                    averageLead={averageLead}
                                    id={userInfo?.id}
                                    accessToken={accessToken}
                                    selectedDate={selectedDate}
                                />
                            </Col>
                            <Col xs={12} lg={8} className="mt-3">
                                <Card
                                    className={isMobile ? 'w-100' : 'me-2'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <ChartBar
                                            monthlyLead={monthlyLead}
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className='me-2 mt-4'>
                            <Col lg={4}>
                                <Form.Control
                                    data-bs-theme={theme === 'light' ? 'dark' : ''}
                                    type='month'
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                    style={formStyles.input}
                                    max={maxDate}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={12} lg={6} className="mt-3 d-flex">
                                <Card
                                    className={isMobile ? 'w-100' : 'w-100'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <ChartDonutCustomer id={userInfo?.id} accessToken={accessToken} selectedDate={selectedDate} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={12} lg={6} className="mt-3 d-flex">
                                <Card
                                    className={isMobile ? 'w-100' : 'w-100'}
                                    style={{
                                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                                        borderRadius: '10px',
                                        height: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <ChartDonutProduct id={userInfo?.id} accessToken={accessToken} selectedDate={selectedDate} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <br />
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </div>
    )
}

export default Dashboard
